<template>
  <v-app>
    <Navbar />
    <v-main class="te-main">
      <router-view />
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Navbar from "./components/Navbar.vue";
import Footer from "./components/Footer.vue";
export default {
  name: "App",
  components: {
    Navbar,
    Footer,
  },
};
</script>

<style lang="scss">
@import './styles/tokens';

.te-main {
  padding-top: 0;
}

.v-toolbar__content {
  max-width: 1250px;
  padding: 0 16px !important;
  margin: 0 auto;
}

.v-application--is-ltr .v-toolbar__content > .v-btn.v-btn--icon:last-child {
  margin-right: 0 !important;
  margin-left: 12px;
}

.container {
  max-width: 1200px !important;
  margin-right: auto !important;
  margin-left: auto !important;
  padding: 16px !important;
}

p {
  margin-bottom: 0 !important;
  font-size: var(--te-font-body-sm);
  line-height: var(--te-line-normal);
  letter-spacing: 0.01em;
  color: var(--te-text-muted);
}

.v-btn {
  font-size: var(--te-font-body-sm) !important;
  font-weight: 500 !important;
  letter-spacing: 0.02em !important;
  text-transform: none !important;
  border-radius: $te-radius-sm !important;
}

.v-input input,
.v-input textarea {
  font-size: var(--te-font-body-sm) !important;
  letter-spacing: 0.02em !important;
  border: none !important;
}

.v-input .v-label {
  font-size: var(--te-font-caption) !important;
  letter-spacing: 0.03em !important;
}

.v-input__icon .v-icon.v-icon,
.v-select-list .v-icon.v-icon {
  font-size: 18px !important;
}

.v-text-field--outlined.v-input--is-focused fieldset {
  border-width: 2px !important;
  border-color: $te-primary !important;
}

.v-text-field--outlined.v-input--has-state fieldset {
  border-width: 2px !important;
}

.v-input .v-input__slot {
  padding: 0 14px !important;
  min-height: 44px !important;
  border-radius: $te-radius-sm !important;
}

.v-input .v-input__slot .v-input__prepend-inner {
  margin-top: 8px !important;
}

img {
  height: 100%;
  width: 100%;
  display: block;
  object-fit: cover;
}

.text__overflow {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>
